<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="125px" inline size="mini">
      <el-form-item label="设备名称">
        <el-input v-model="query.devicename" clearable placeholder="请输入设备名称"></el-input>
      </el-form-item>
      <!-- 创建起始时间段 -->
      <el-form-item label="操作时间段">
        <el-date-picker
          v-model="opPeriod"
          value-format="yyyy-MM-dd"
          unlink-panels
          type="daterange"
          range-separator="至"
          start-placeholder="操作起始时间"
          end-placeholder="操作结束时间"
        ></el-date-picker>
      </el-form-item>
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 表格数据展示区域 -->
      <el-table :data="logList" style="width: 100%" height="650px" border="" stripe>
        <el-table-column prop="devicename" label="devicename" width="150"></el-table-column>
        <el-table-column prop="devicetype" label="devicetype" width="120"></el-table-column>
        <el-table-column prop="adcvalue" label="adcvalue" width="120"></el-table-column>
        <el-table-column prop="ledstatus" label="ledstatus" width="120"></el-table-column>
        <el-table-column prop="lockerstatus" label="lockerstatus" width="120"></el-table-column>
        <el-table-column prop="voltagestatus" label="voltagestatus" width="120"></el-table-column>
        <el-table-column prop="controlvalue" label="controlvalue" width="120"></el-table-column>
        <el-table-column prop="minutevalue" label="minutevalue" width="120"></el-table-column>
        <el-table-column prop="signalvalue" label="signalvalue" width="120"></el-table-column>
        <el-table-column prop="warnvalue" label="warnvalue" width="120"></el-table-column>
        <el-table-column prop="operatordate" label="operatordate"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { deviceLog } from '@/API/device'
export default {
  name: 'auth',
  data() {
    return {
      query: {
        pageSize: 10,
        curPage: 1,
        opStart: '',
        opEnd: ''
      },
      // 创建起始时间段
      opPeriod: [],
      total: 0,
      logList: []
    }
  },
  mounted() {
    this.queryLog()
  },
  methods: {
    async queryLog() {
      this.logList = []
      const { data: res } = await deviceLog(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.logList = res.data.entities
      this.total = res.data.totalSize
    },
    seach() {
      this.query.curPage = 1
      if (this.opPeriod != null && this.opPeriod !== []) {
        this.query.opStart = this.opPeriod[0]
        this.query.opEnd = this.opPeriod[1]
      } else {
        this.query.opStart = ''
        this.query.opEnd = ''
      }
      this.queryLog()
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.queryLog()
    },
    // 监听curPage
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.queryLog()
    }
  }
}
</script>

<style lang="less" scoped>
.el-pagination {
  margin-top: 30px;
}
.expand {
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 33%;
  }
}
</style>
